<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-3 box">
        <div>
          <qa-list-input label="프로젝트" v-if="qaProjectList.length>0"
                         :list="qaProjectList" :height="182" @selected="onSelectProject"
                         @update="updateProject"
                         @enter="enterProject"
                         @delete="deleteProject"></qa-list-input>
          <div class="flex" style="margin-top:12px">
            <div style="width:136px;margin-right:12px">
              <admin-form-item label="구분">
                <select v-model="ftype" style="width:100%">
                  <option v-for="(item,idx) in fTypeOptions" :key="'ftype-'+idx" :value="item.value">{{ item.label }}
                  </option>
                </select>
              </admin-form-item>
            </div>
            <qa-list-input label="기능 대분류" :key="`qa-${device}-${ftype}`"
                           :list="qaList" :height="182" @selected="onSelectF1"
                           @update="updateF1"
                           @enter="enterF1"
                           @delete="deleteF1"></qa-list-input>
          </div>
        </div>
      </div>
      <div v-if="qaItem" class="column is-9">
        <tab :value.sync="tab" :options="tabs"></tab>

        <div v-if="tab === 0" class="box" style="margin-top:8px" :key="`front-${qaItem.id}`">
          <div class="columns">
            <div class="column is-4">
              <admin-form-item label="디바이스">
                <select v-model="device" style="width:100%">
                  <option value="pc">PC</option>
                  <option value="mobile">모바일</option>
                  <option value="common">공통</option>
                </select>
              </admin-form-item>
              <div class="flex">
                <qa-list-input style="margin-right:8px" label="플로우 뷰" :list="qaItem.front"
                               @enter="enterFrontFeature"
                               @update="updateFrontFeature"
                               @delete="deleteFrontFeature"
                               @selected="onSelectFeature"></qa-list-input>
                <qa-list-input v-if="selected.front.feature" label="노출경로"
                               :key="`qa-list-location-${selected.front.feature.id}`"
                               :list="selected.front.feature.location"
                               @enter="enterFrontLocation"
                               @update="updateFrontLocation"
                               @delete="deleteFrontLocation"
                               @selected="res => selected.front.location = res"></qa-list-input>
              </div>
            </div>
            <div class="column is-8" v-if="selected.front.location" :key="`qa-action-${selected.front.location.id}`">
              <div class="label">경로 해당 UI / 기대결과</div>
              <div class="table-wrapper" style="height:250px">
                <table>
                  <thead>
                  <th>UI/액션</th>
                  <th>기대결과</th>
                  <th>편집</th>
                  </thead>
                  <tbody>
                  <tr v-for="(action,idx) in selected.front.location.action" :key="'action-'+idx">
                    <td>{{ action.name }}</td>
                    <td>{{ action.result }}</td>
                    <td>
                      <i class="icon-delete material-icons unselect" @click="editAction(action)">edit</i>
                      <i class="icon-delete material-icons unselect" @click="deleteAction(idx)">delete</i>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div style="margin-top:4px" class="flex">
                <select v-model="actionForm.name" style="height:30px">
                  <option v-for="(item,idx) in actionOption" :key="`action-option-${idx}`"
                          :value="item.value">{{ item.label }}
                  </option>
                </select>
                <textarea style="flex:1;margin:0 8px" v-model="actionForm.result" rows="5"></textarea>
                <button style="width:80px" @click="enterAction">추가</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="tab === 1" class="box" style="margin-top:8px" :key="`admin-${qaItem.id}`">
          <div class="columns">
            <div class="column is-4">
              <qa-list-input label="위치" :list="qaItem.admin"
                             @enter="enterAdminLocation"
                             @update="updateAdminLocation"
                             @delete="deleteAdminLocation"
                             @selected="res => selected.admin.location = res"></qa-list-input>
            </div>
            <div class="column is-8" v-if="selected.admin.location">
              <div class="label">기능 / 기대결과</div>
              <div class="table-wrapper" style="height:250px">
                <table>
                  <thead>
                  <th>기능</th>
                  <th>기대결과</th>
                  <th>편집</th>
                  </thead>
                  <tbody>
                  <tr v-for="(item,idx) in selected.admin.location.feature" :key="`admin-feature-${idx}`">
                    <td>{{ item.content }}</td>
                    <td>{{ item.result }}</td>
                    <td>
                      <i class="icon-delete material-icons unselect" @click="editAdminFeature(item)">edit</i>
                      <i class="icon-delete material-icons unselect" @click="deleteAdminFeature(idx)">delete</i>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div style="margin-top:4px" class="flex">
                <input type="text" v-model="adminForm.content" style="width:180px;height:30px">
                <textarea v-model="adminForm.result" style="flex:1;margin:0 8px" rows="5"></textarea>
                <button style="width:80px" @click="enterAdminFeature">추가</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="tab === 2" class="box" style="margin-top:8px" :key="`builder-${qaItem.id}`">
          <div class="columns">
            <div class="column is-4">
              <qa-list-input label="위치" :list="qaItem.builder"
                             @enter="enterBuilderLocation"
                             @update="updateBuilderLocation"
                             @delete="deleteBuilderLocation"
                             @selected="res => selected.builder.location = res"></qa-list-input>
            </div>
            <div class="column is-8" v-if="selected.builder.location">
              <div class="label">기능 / 기대결과</div>
              <div class="table-wrapper" style="height:250px">
                <table>
                  <thead>
                  <th>기능</th>
                  <th>기대결과</th>
                  <th>편집</th>
                  </thead>
                  <tbody>
                  <tr v-for="(item,idx) in selected.builder.location.feature" :key="`builder-feature-${idx}`">
                    <td>{{ item.content }}</td>
                    <td>{{ item.result }}</td>
                    <td>
                      <i class="icon-delete material-icons unselect" @click="editBuilderFeature(item)">edit</i>
                      <i class="icon-delete material-icons unselect" @click="deleteBuilderFeature(idx)">delete</i>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div style="margin-top:4px" class="flex">
                <input type="text" v-model="builderForm.content" style="width:180px;height:30px">
                <textarea v-model="builderForm.result" style="flex:1;margin:0 8px" rows="5"></textarea>
                <button style="width:80px" @click="enterBuilderFeature">추가</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="columns" v-if="qaItem">
      <div class="column is-7">
        <!-- QA 시트 -->
        <div class="box">
          <div class="flex-between" style="margin-bottom: 4px">
            <div class="label">QA Sheet</div>
            <button @click="$modal.show('qaCreateModal')">추가</button>
          </div>
          <div class="table-wrapper" style="height:250px">
            <table>
              <thead>
              <th>위치</th>
              <th>요청내용</th>
              <th>우선순위</th>
              <th>요청자</th>
              <th>담당자</th>
              <th>작업 완료</th>
              <th>요청자 확인</th>
              <th>편집</th>
              </thead>
              <tbody>
              <tr v-for="(item,idx) in qaItem.sheet" :key="`qa-item-${idx}`">
                <td class="size-12" style="text-align: left !important">{{ locationText(item.location) }}<br><span
                  class="size-11">{{ item.location.result }}</span></td>
                <td>{{ item.req_content }}</td>
                <td>{{ item.priority }}</td>
                <td>{{ item.req_user_name }}</td>
                <td>{{ item.task_user_name }}</td>
                <td>
                  <template v-if="item.task_end_date">
                    <div class="size-11">{{ datesFormat(item.task_end_date, 'date_time_2') }}</div>
                    <button v-if="item.task_user === $store.getters.admin.id"
                            @click="clickQaCheck(item, 'task_end_date', true)">완료 취소
                    </button>
                  </template>
                  <template v-else>
                    <button v-if="item.task_user === $store.getters.admin.id"
                            @click="clickQaCheck(item, 'task_end_date', false)">완료
                    </button>
                    <div v-else>완료 전</div>
                  </template>
                </td>
                <td>
                  <template v-if="item.req_check_date">
                    <div class="size-11">{{ datesFormat(item.req_check_date, 'date_time_2') }}</div>
                    <button v-if="item.req_user === $store.getters.admin.id"
                            @click="clickQaCheck(item, 'req_check_date', true)">확인 취소
                    </button>
                  </template>
                  <template v-else>
                    <button v-if="item.req_user === $store.getters.admin.id"
                            @click="clickQaCheck(item, 'req_check_date', false)">확인
                    </button>
                    <div v-else>확인 전</div>
                  </template>
                </td>
                <td>
                  <i class="icon-delete material-icons unselect" @click="editQa(item)">edit</i>
                  <i class="icon-delete material-icons unselect" @click="deleteQa(idx)">delete</i>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="column is-5">
        <!-- 개선사항 -->
        <div class="box">
          <div class="flex-between" style="margin-bottom: 4px">
            <div class="label">개선사항</div>
            <button @click="$modal.show('qaImproveModal')">추가</button>
          </div>
          <table>
            <thead>
            <th>위치</th>
            <th>제안내용</th>
            <th>작성자</th>
            <th>진행여부</th>
            <th>편집</th>
            </thead>
            <tbody>
            <tr v-for="(item,idx) in qaItem.improve" :key="`improve-item-${idx}`">
              <td class="size-12" style="text-align: left !important">{{ locationText(item.location) }}<br><span
                class="size-11">{{ item.location.result }}</span></td>
              <td>{{ item.req_content }}</td>
              <td>{{ item.req_user_name }}</td>
              <td>
                <div>{{ improveStatusText(item.status) }}</div>
                <div class="size-11">({{ item.status_time }})</div>
                <div class="flex-center" style="margin-top:4px" v-if="item.req_user === $store.getters.admin.id">
                  <button v-if="!item.vUpdate" @click="item.vUpdate=true">상태 변경</button>
                  <template v-else>
                    <select v-model="improveStatus" style="margin-right:4px">
                      <option v-for="optItem in improveOption" :key="'improve-item-'+optItem.value"
                              :value="optItem.value">{{ optItem.label }}
                      </option>
                    </select>
                    <button @click="updateImprove(item)">변경</button>
                  </template>
                </div>
              </td>
              <td>
                <i class="icon-delete material-icons unselect" @click="editImprove(item)">edit</i>
                <i class="icon-delete material-icons unselect" @click="deleteImprove(idx)">delete</i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <modal name="editModal" height="auto" :width="800">
      <div style="padding:20px" class="flex">
        <select v-model="actionForm.name" style="height:30px">
          <option v-for="(item,idx) in actionOption" :key="`action-option-${idx}`"
                  :value="item.value">{{ item.label }}
          </option>
        </select>
        <textarea type="text" v-model="actionForm.result"
                  style="flex:1;margin:0 8px" rows="5"></textarea>
        <button style="width:80px" @click="enterEditAction">수정</button>
      </div>
    </modal>
    <modal name="editAdminModal" height="auto" :width="800">
      <div style="padding:20px" class="flex">
        <input type="text" v-model="adminForm.content" style="width:180px;height:30px">
        <textarea type="text" v-model="adminForm.result" style="flex:1;margin:0 8px" rows="5"></textarea>
        <button style="width:80px" @click="enterEditAdminFeature">수정</button>
      </div>
    </modal>
    <modal name="editBuilderModal" height="auto" :width="800">
      <div style="padding:20px" class="flex">
        <input type="text" v-model="builderForm.content" style="width:180px;height:30px">
        <textarea type="text" v-model="builderForm.result" style="flex:1;margin:0 8px" rows="5"></textarea>
        <button style="width:80px" @click="enterEditBuilderFeature">수정</button>
      </div>
    </modal>
    <modal name="qaCreateModal" height="auto">
      <qa-edit-modal v-if="qaItem" @close="closeQaEditModal" editType="sheet"
                     :pftype="ftype" :pdevice="device" :feature="qaItem.id"></qa-edit-modal>
    </modal>
    <modal name="qaUpdateModal" height="auto" v-if="v.update">
      <qa-update-modal @close="closeQaUpdateModal" editType="sheet"
                       :item="selected.sheet"></qa-update-modal>
    </modal>
    <modal name="qaImproveModal" height="auto">
      <qa-edit-modal v-if="qaItem" @close="closeQaImproveModal" editType="improve"
                     :pftype="ftype" :pdevice="device" :feature="qaItem.id"></qa-edit-modal>
    </modal>
    <modal name="qaImproveUpdateModal" height="auto" v-if="v.improve_update">
      <qa-update-modal @close="closeImproveUpdateModal" editType="improve"
                       :item="selected.improve"></qa-update-modal>
    </modal>
  </div>
</template>

<script>
  import LpRadio from "../../../module/common/LpRadio";
  import LpDropdown from "../../../module/common/LpDropdown";
  import Tab from "../../../module/common/Tab";
  import QaListInput from "../../../module/common/qa/QaListInput";
  import QaEditModal from "../../../module/common/qa/QaEditModal";
  import QaUpdateModal from "../../../module/common/qa/QaUpdateModal";

  export default {
    name: "QualityAssurance",
    components: {QaUpdateModal, QaEditModal, QaListInput, Tab, LpDropdown, LpRadio},
    created() {
      this.getProjects();
      this.getQa();
    },
    watch: {
      qaProject() {
        this.getQa();
      },
      device() {
        this.getQa();
      },
      ftype() {
        this.getQa();
      }
    },
    data() {
      return {
        url: 'admin/launchpack/qa',
        v: {
          addf1: false,
          update: false,
          improve_update: false
        },
        input: {
          f1: ''
        },
        selected: {
          front: {
            feature: undefined,
            location: undefined,
            action: undefined
          },
          admin: {
            location: undefined,
            feature: undefined
          },
          builder: {
            location: undefined,
            feature: undefined
          },
          sheet: null,
          improve: null
        },
        device: 'pc',
        ftype: 'common',
        fTypeOptions: [
          {
            label: '전체',
            value: 'all'
          },
          {
            label: '공통',
            value: 'common'
          },
          {
            label: '기본',
            value: 'basic'
          },
          {
            label: '디자인',
            value: 'design'
          },
          {
            label: '팩',
            value: 'pack'
          },
          {
            label: '자동설치 플러그인',
            value: 'auto_plugin'
          },
          {
            label: '수동설치 플러그인',
            value: 'passive_plugin'
          },
          {
            label: '템플릿',
            value: 'template'
          }
        ],
        actionOption: [
          {
            label: '클릭',
            value: '클릭'
          },
          {
            label: '마우스오버',
            value: '마우스오버'
          },
          {
            label: '스크롤',
            value: '스크롤'
          },
          {
            label: '드래그',
            value: '드래그'
          },
          {
            label: '터치',
            value: '터치'
          },
          {
            label: 'UI',
            value: 'UI'
          }
        ],
        improveOption: [
          {
            label: '진행 전',
            value: 0,
          },
          {
            label: '진행',
            value: 1,
          },
          {
            label: '진행안함',
            value: 2,
          },
          {
            label: '보류',
            value: 3,
          }
        ],
        actionForm: {
          name: '클릭',
          result: ''
        },
        adminForm: {
          content: '',
          result: ''
        },
        builderForm: {
          content: '',
          result: ''
        },
        f1: '',
        qaProject: 1,
        qaProjectList: [],
        qaList: [],
        tab: 0,
        tabs: [
          {
            label: '프론트',
            value: 0,
          },
          {
            label: '백오피스',
            value: 1
          },
          {
            label: '빌더',
            value: 2
          },
        ],
        qaItem: undefined,
        improveStatus: 1
      }
    },
    computed: {
      /*qaName() {
        if (this.qaProject.length === 0) return '';

        let result = this.qaProjectList.filter(i => {
          return i.id === this.qaProject
        })[0].name;
        result += `${this.device}`;
        return result;
      }*/
    },
    methods: {
      improveStatusText(status) {
        return this.improveOption.filter(i => {
          return status === i.value
        })[0].label;
      },
      initSelected() {
        this.selected = {
          front: {
            feature: undefined,
            location: undefined
          },
          admin: {
            location: undefined
          },
          builder: {
            location: undefined
          },
        };
      },
      getProjects() {
        this.$axios.get('admin/launchpack/qa_project').then(res => {
          this.qaProjectList = res.data;
        });
      },
      getQa() {
        // this.qaItem = undefined;
        let ftype = '';
        if (this.ftype !== 'all') {
          ftype = `&ftype=${this.ftype}`;
        }
        this.$axios.get(`${this.url}?project=${this.qaProject}${ftype}`).then(res => {
          this.qaList = res.data;
        });
      },
      onSelectProject(item) {
        this.qaProject = item.id;
      },
      onSelectF1(item) {
        this.initSelected();
        this.$axios.get(`${this.url}/${item.id}?device=${this.device}`).then(res => {
          res.data.improve.forEach(i => {
            i.vUpdate = false;
          });
          this.qaItem = res.data;
        });
      },
      onSelectFeature(item) {
        this.initSelected();
        this.selected.front.feature = item;
      },
      enterF1(name) {
        this.$axios.post(`${this.url}`, {
          project_id: this.qaProject,
          feature: name,
          ftype: this.ftype,
        }).then(res => {
          this.qaList.push({
            name: name,
            id: res.data.id
          });
        });
      },
      enterFrontFeature(name) {
        this.$axios.post(`${this.url}/${this.qaItem.id}/front_feature`, {device: this.device, 'name': name}).then(res => {
          this.qaItem.front.push({
            name: name,
            id: res.data.id,
            location: []
          });
        });
      },
      enterFrontLocation(name) {
        this.$axios.post(`${this.url}/${this.qaItem.id}/front_feature/${this.selected.front.feature.id}/location`, {'name': name}).then(res => {
          this.selected.front.feature.location.push({
            name: name,
            id: res.data.id,
            action: []
          });
        });
      },
      enterAction() {
        this.actionForm.action_type = this.actionForm.name === 'UI' ? 'ui' : 'action';
        this.$axios.post(`${this.url}/${this.qaItem.id}/front_feature/${this.selected.front.feature.id}/location/${this.selected.front.location.id}/action`,
          this.actionForm).then(res => {
          this.selected.front.location.action.push({
            name: this.actionForm.name,
            result: this.actionForm.result,
            id: res.data.id
          });
          this.actionForm = {
            name: '클릭',
            result: ''
          }
        });
      },
      enterEditAction() {
        this.$axios.patch(`${this.url}/${this.qaItem.id}/front_feature/${this.selected.front.feature.id}/location/${this.selected.front.location.id}/action/${this.selected.front.action.id}`,
          this.actionForm).then(() => {
          this.selected.front.action.name = this.actionForm.name;
          this.selected.front.action.result = this.actionForm.result;
          this.actionForm = {
            name: '클릭',
            result: ''
          }
          this.$modal.hide('editModal');
        });
      },
      enterEditAdminFeature() {
        this.$axios.patch(`${this.url}/${this.qaItem.id}/admin_location/${this.selected.admin.location.id}/feature/${this.selected.admin.feature.id}`,
          this.adminForm).then(() => {
          this.selected.admin.feature.content = this.adminForm.content;
          this.selected.admin.feature.result = this.adminForm.result;
          this.adminForm = {
            content: '',
            result: ''
          }
          this.$modal.hide('editAdminModal');
        });
      },
      enterEditBuilderFeature() {
        this.$axios.patch(`${this.url}/${this.qaItem.id}/builder_location/${this.selected.builder.location.id}/feature/${this.selected.builder.feature.id}`,
          this.builderForm).then(() => {
          this.selected.builder.feature.content = this.builderForm.content;
          this.selected.builder.feature.result = this.builderForm.result;
          this.builderForm = {
            content: '',
            result: ''
          }
          this.$modal.hide('editBuilderModal');
        });
      },
      enterAdminLocation(name) {
        this.$axios.post(`${this.url}/${this.qaItem.id}/admin_location`, {'name': name}).then(res => {
          this.qaItem.admin.push({
            name: name,
            id: res.data.id,
            feature: []
          });
        });
      },
      enterAdminFeature() {
        if (this.adminForm.result === '') return;

        this.$axios.post(`${this.url}/${this.qaItem.id}/admin_location/${this.selected.admin.location.id}/feature`,
          this.adminForm).then(res => {
          this.adminForm.id = res.data.id;
          this.selected.admin.location.feature.push(this.cloneItem(this.adminForm));
          this.adminForm = {
            content: '',
            result: ''
          }
        });
      },
      enterBuilderLocation(name) {
        this.$axios.post(`${this.url}/${this.qaItem.id}/builder_location`, {'name': name}).then(res => {
          this.qaItem.builder.push({
            name: name,
            id: res.data.id,
            feature: []
          });
        });
      },
      enterBuilderFeature() {
        if (this.builderForm.result === '') return;
        this.$axios.post(`${this.url}/${this.qaItem.id}/builder_location/${this.selected.builder.location.id}/feature`,
          this.builderForm).then(res => {
          this.builderForm.id = res.data.id;
          this.selected.builder.location.feature.push(this.cloneItem(this.builderForm));
          this.builderForm = {
            content: '',
            result: ''
          }
        });
      },
      enterProject(name) {
        this.$axios.post('admin/launchpack/qa_project', {'name': name}).then(res => {
          this.qaProjectList.push({
            name: name,
            id: res.data.id
          });
        });
      },
      updateProject(idx, name) {
        this.$axios.patch(`admin/launchpack/qa_project/${this.qaProjectList[idx].id}`, {name: name});
      },
      deleteProject(idx) {
        if(confirm(this.qaProjectList[idx].name + ' 프로젝트를 삭제 하시겠습니까?')) {
          this.$axios.delete(`admin/launchpack/qa_project/${this.qaProjectList[idx].id}`).then(() => {
            removeIndex(this.qaProjectList, idx);
          });
        }
      },
      updateF1(idx, name) {
        this.$axios.patch(`${this.url}/${this.qaList[idx].id}`, {feature: name});
      },
      deleteF1(idx) {
        if(confirm(this.qaList[idx].name + ' 항목을 삭제하시겠습니까?')) {
          this.$axios.delete(`${this.url}/${this.qaList[idx].id}`).then(() => {
            removeIndex(this.qaList, idx);
          });
        }
      },
      updateFrontFeature(idx, name) {
        this.$axios.patch(`${this.url}/${this.qaItem.id}/front_feature/${this.qaItem.front[idx].id}`, {name: name});
      },
      deleteFrontFeature(idx) {
        if(confirm(this.qaItem.front[idx].name + ' 항목을 삭제하시겠습니까?')) {
          this.$axios.delete(`${this.url}/${this.qaItem.id}/front_feature/${this.qaItem.front[idx].id}`).then(() => {
            removeIndex(this.qaItem.front, idx);
          });
        }
      },
      updateFrontLocation(idx, name) {
        this.$axios.patch(`${this.url}/${this.qaItem.id}/front_feature/${this.selected.front.feature.id}/location/${this.selected.front.feature.location[idx].id}`, {name: name});
      },
      deleteFrontLocation(idx) {
        if(confirm(this.selected.front.feature.location[idx].name + '항목을 삭제하시겠습니까?')) {
          this.$axios.delete(`${this.url}/${this.qaItem.id}/front_feature/${this.selected.front.feature.id}/location/${this.selected.front.feature.location[idx].id}`).then(() => {
            removeIndex(this.selected.front.feature.location, idx);
          });
        }
      },
      deleteAction(idx) {
        if(confirm(this.selected.front.location.action[idx].name + ' 항목을 삭제하시겠습니까?')) {
          this.$axios.delete(`${this.url}/${this.qaItem.id}/front_feature/${this.selected.front.feature.id}/` +
            `location/${this.selected.front.location.id}/action/${this.selected.front.location.action[idx].id}`).then(() => {
            removeIndex(this.selected.front.location.action, idx);
          });
        }
      },
      editAction(action) {
        this.selected.front.action = action;
        this.actionForm.name = action.name;
        this.actionForm.result = action.result;
        this.$modal.show('editModal');
      },
      updateAdminLocation(idx, name) {
        this.$axios.patch(`${this.url}/${this.qaItem.id}/admin_location/${this.qaItem.admin[idx].id}`, {name: name});
      },
      deleteAdminLocation(idx) {
        if(confirm(this.qaItem.admin[idx].name + ' 항목을 삭제하시겠습니까?')) {
          this.$axios.delete(`${this.url}/${this.qaItem.id}/admin_location/${this.qaItem.admin[idx].id}`).then(() => {
            removeIndex(this.qaItem.admin, idx);
          });
        }
      },
      deleteAdminFeature(idx) {
        if(confirm(this.selected.admin.location.feature[idx].content + ' 항목을 삭제하시겠습니까?')) {
          this.$axios.delete(`${this.url}/${this.qaItem.id}/admin_location/${this.selected.admin.location.id}/` +
            `feature/${this.selected.admin.location.feature[idx].id}`).then(() => {
            removeIndex(this.selected.admin.location.feature, idx);
          });
        }
      },
      editAdminFeature(feature) {
        this.selected.admin.feature = feature;
        this.adminForm.content = feature.content;
        this.adminForm.result = feature.result;
        this.$modal.show('editAdminModal');
      },
      updateBuilderLocation(idx, name) {
        this.$axios.patch(`${this.url}/${this.qaItem.id}/builder_location/${this.qaItem.builder[idx].id}`, {name: name});
      },
      deleteBuilderLocation(idx) {
        if(confirm(this.qaItem.builder[idx].name + ' 항목을 삭제하시겠습니까?')) {
          this.$axios.delete(`${this.url}/${this.qaItem.id}/builder_location/${this.qaItem.builder[idx].id}`).then(() => {
            removeIndex(this.qaItem.builder, idx);
          });
        }
      },
      deleteBuilderFeature(idx) {
        if(confirm(this.selected.builder.location.feature[idx].content + ' 항목을 삭제하시겠습니까?')) {
          this.$axios.delete(`${this.url}/${this.qaItem.id}/builder_location/${this.selected.builder.location.id}/` +
            `feature/${this.selected.builder.location.feature[idx].id}`).then(() => {
            removeIndex(this.selected.builder.location.feature, idx);
          });
        }
      },
      editBuilderFeature(feature) {
        this.selected.builder.feature = feature;
        this.builderForm.content = feature.content;
        this.builderForm.result = feature.result;
        this.$modal.show('editBuilderModal');
      },
      closeQaEditModal() {
        this.$modal.hide('qaCreateModal');
        let item = this.qaList.filter(i => {
          return i.id === this.qaItem.id
        })[0];
        this.onSelectF1(item);
      },
      closeQaImproveModal() {
        this.$modal.hide('qaImproveModal');
        let item = this.qaList.filter(i => {
          return i.id === this.qaItem.id
        })[0];
        this.onSelectF1(item);
      },
      locationText(item) {
        let result = '';
        if (item.type === 'front_action') {
          result = `[프론트] ${item.location_name} > ${item.feature_name} > ${item.name}`;
        } else {
          result = `[${item.type === 'admin_feature' ? '백오피스' : '빌더'}] ${item.location_name} > ${item.content}`;
        }

        return result;
      },
      clickQaCheck(item, key, isCancel) {
        let date = '';
        if (!isCancel) {
          date = this.moment().format('YYYY-MM-DD HH:mm:ss');
        }
        let params = {};
        params[key] = date;
        this.$axios.patch(`${this.url}/${this.qaItem.id}/sheet/${item.id}`, params).then(res => {
          if (res.status === 200) {
            item[key] = date;
          }
        });
      },
      updateImprove(item) {
        this.$axios.patch(`${this.url}/${this.qaItem.id}/improve/${item.id}`, {'status': this.improveStatus}).then(res => {
          if (res.status === 200) {
            item.status = this.improveStatus;
            item.status_time = this.moment().format('YYYY-MM-DD HH:mm');
            item.vUpdate = false;
          }
        }).catch(() => {
          item.vUpdate = false;
          this.toast('상태변경에 실패했습니다.');
        })
      },
      editQa(item) {
        this.selected.sheet = item;
        this.v.update = true;
        setTimeout(()=>{
          this.$modal.show('qaUpdateModal');
        },300);
      },
      closeQaUpdateModal() {
        this.$modal.hide('qaUpdateModal');
        this.selected.sheet = undefined;
        setTimeout(()=>{
          this.v.update = false;
        },300);
      },
      deleteQa(idx) {
        if(confirm('해당 시트를 삭제 하시겠습니까?')) {
          this.$axios.delete(`${this.url}_sheet/${this.qaItem.sheet[idx].id}`).then(()=>{
            removeIndex(this.qaItem.sheet, idx);
          });
        }
      },
      editImprove(item) {
        this.selected.improve = item;
        this.v.improve_update = true;
        setTimeout(()=>{
          this.$modal.show('qaImproveUpdateModal');
        },300);
      },
      closeImproveUpdateModal() {
        this.$modal.hide('qaImproveUpdateModal');
        this.selected.improve = undefined;
        setTimeout(()=>{
          this.v.improve_update = false;
        },300);
      },
      deleteImprove(idx) {
        if(confirm('해당 사항을 삭제 하시겠습니까?')) {
          this.$axios.delete(`${this.url}_improve/${this.qaItem.improve[idx].id}`).then(()=>{
            removeIndex(this.qaItem.improve, idx);
          });
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .table-wrapper
    border 1px solid #dddddd
    overflow-y auto

  table
    background white
    width 100%
    overflow-y auto
    border-collapse separate
    border-spacing 0
    font-size 13px

  th
    position sticky
    top 0
    background white

  th, td
    border 1px solid #dddddd
    padding 4px
    text-align center !important
    white-space pre-line

  input
  textarea
  select
    border 1px solid #dddddd
    padding 4px 8px
    border-radius 4px
    max-width 100%

  .label
    font-size 13px
    margin-bottom 4px

  .flex-column
    display flex
    flex-direction column

  .icon-delete
    font-size 20px

  .icon-delete:hover
    color #ff5722

  button
    border 0
    padding 5px
    height 30px
    background #dddddd
    border-radius 4px
    color #242428

  button:hover
    cursor pointer
    background #ff5722
    color white
</style>
